import { render } from "./ModalRefund.vue?vue&type=template&id=815b181a&scoped=true"
import script from "./ModalRefund.vue?vue&type=script&lang=js"
export * from "./ModalRefund.vue?vue&type=script&lang=js"

import "./ModalRefund.vue?vue&type=style&index=0&id=815b181a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815b181a"]])

export default __exports__